// extracted by mini-css-extract-plugin
export default {"root":"Search_root__lYSLM","input":"Search_input__3c9L+"};